/**
 * `/listings` — kept so nothing that pointed here breaks.
 *
 * What this account has published is a tab of the gallery now, not a page of its
 * own, so the address that used to render it forwards to that tab. The route
 * stays rather than being deleted because a bookmark, a link somebody was sent,
 * or a phone's home-screen shortcut is not a typo to be answered with the
 * not-found page.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/listings')({
  beforeLoad: () => {
    throw redirect({ to: '/gallery', search: { tab: 'mine' } });
  },
});
